<!-- /components/CrudComponent.vue -->
<template>
  <v-container fluid class="pa-0">
    <!-- Card con tu diseño preferido -->
    <v-card outlined>
      <v-card-title>
        <span class="text-subtitle-1 font-weight-medium grey--text text--darken-2">{{ title }}</span>
        <v-spacer></v-spacer>
        <!-- Fila para los botones dentro del título -->
        <v-row justify="end" class="mx-0">
          <v-col cols="auto" class="pa-1">
            <v-btn
              color="primary"
              depressed
              small
              @click="save"
              :disabled="!nombreActual || !datos.value"
            >
              <v-icon left small>{{ editedIndex === -1 ? 'add' : 'save' }}</v-icon>
              {{ editedIndex === -1 ? 'Ingresar' : 'Guardar' }}
            </v-btn>
          </v-col>
          <v-col cols="auto" class="pa-1">
            <v-btn text small @click="clearForm">Limpiar</v-btn>
          </v-col>
           <v-col cols="auto" class="pa-1">
            <v-btn text small color="error" @click="clearTable">Reiniciar Tabla</v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text class="pt-4">
          <v-row align="center">
            <!-- Columna para el nombre (con v-autocomplete funcional) -->
            <v-col cols="12" sm="6" class="py-1">
              <div v-if="datosCrud && datosCrud.length > 0">
                <v-autocomplete
                  v-model="nombreSeleccionado"
                  :search-input.sync="busqueda"
                  auto-select-first
                  :items="localDatosCrud"
                  item-text="name"
                  return-object
                  label="Nombre"
                  placeholder="Buscar o seleccionar"
                  outlined
                  dense
                  hide-details
                  clearable
                  class="style-chooser"
                >
                </v-autocomplete>
              </div>
              <div v-else>
                <v-text-field
                  v-model="datos.name"
                  label="Nombre"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
            </v-col>
            <!-- Columna para el valor -->
            <v-col cols="12" sm="6" class="py-1">
              <v-text-field
                v-model="datos.value"
                label="Valor (Dosis, Frecuencia, etc.)"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
      </v-card-text>
    </v-card>

    <!-- Modal para agregar nuevo valor -->
    <add-new-value-modal-flotante
      v-if="modalVisible"
      @close="closeModal"
      @nuevo-valor="handleNuevoValor"
    />

    <!-- Tabla de datos (con un pequeño margen superior) -->
    <v-data-table
      :headers="headers"
      :items="localItems"
      class="elevation-1 mt-4"
      no-data-text="No se han agregado elementos"
    >
      <!-- Slot para el botón de editar -->
      <template v-slot:item.actions1="{item}">
        <v-icon small @click="editItem(item)">edit</v-icon>
      </template>
      <!-- Slot para el botón de eliminar -->
      <template v-slot:item.actions2="{item}">
        <v-icon small color="error" @click="deleteItem(item)">delete</v-icon>
      </template>
    </v-data-table>
  </v-container>
</template>

<style scoped>
  .style-chooser .v-select__slot {
    text-align: left;
  }
</style>

<script>
// Asegúrate de que la ruta sea correcta
import AddNewValueModalFlotante from "./modals/AddNewValue.vue";

export default {
    name: 'CrudComponent',
    components: { AddNewValueModalFlotante },
    props: {
        title: { type: String, required: true },
        datosCrud: { type: Array, default: () => [] },
        items: { type: Array, default: () => [] },
    },
    data() {
        return {
            headers: [
                { text: 'Nombre', value: 'name', width: '50%' },
                { text: 'Valor', value: 'value', sortable: false },
                { text: 'Editar', value: 'actions1', sortable: false, align: 'center', width: '60px' },
                { text: 'Eliminar', value: 'actions2', sortable: false, align: 'center', width: '60px' },
            ],
            localItems: [],
            localDatosCrud: [],
            nombreSeleccionado: null,
            busqueda: '',
            datos: { name: '', value: '' },
            modalVisible: false,
            editedIndex: -1,
        };
    },
    computed: {
        // Nombre efectivo: el ítem elegido o, si el texto tipeado coincide exactamente
        // con una opción de la lista, esa opción (aunque no se haya seleccionado del desplegable).
        nombreActual() {
            if (this.datos.name) return this.datos.name;
            const texto = (this.busqueda || '').trim().toLowerCase();
            if (!texto) return '';
            const match = this.localDatosCrud.find(i => i.name && i.name.trim().toLowerCase() === texto);
            return match ? match.name : '';
        }
    },
    /*computed: {
        sanitizedDatosCrud() {
            if (!this.datosCrud || !Array.isArray(this.datosCrud)) return [];
            return this.datosCrud.map(item => ({
                ...item,
                name: item.name ? String(item.name).trim() : ''
            }));
        }
    },*/
    watch: {
        datosCrud: {
        handler(newVal) {
            if (!newVal || !Array.isArray(newVal)) {
                this.localDatosCrud = [];
                return;
            }
            // Creamos una copia estable que solo se actualiza cuando la prop cambia.
            this.localDatosCrud = newVal.map(item => ({
                ...item,
                name: item.name ? String(item.name).trim() : ''
            }));
        },
        immediate: true, // Se ejecuta tan pronto como el componente se monta
        deep: true       // Observa cambios profundos dentro del array
    },

    // Este watcher para items no cambia
    items: {
        handler(newVal) { this.localItems = JSON.parse(JSON.stringify(newVal || [])); },
        immediate: true,
    },

    // Este watcher para la selección no cambia
    nombreSeleccionado(nuevoValor) {
        if (nuevoValor && typeof nuevoValor === 'object') {
            if (nuevoValor.name === 'Agregar nuevo valor') {
                this.modalVisible = true;
                this.$nextTick(() => { this.nombreSeleccionado = null; });
            } else {
                this.datos.name = nuevoValor.name;
            }
        } else if (!nuevoValor) {
            this.datos.name = '';
        }
    }
    },
    methods: {
        closeModal() { this.modalVisible = false; },
        clearForm() {
            this.datos = { name: '', value: '' };
            this.nombreSeleccionado = null;
            this.busqueda = '';
            this.editedIndex = -1;
        },
        clearTable() {
            this.$emit('update:items', []);
            this.clearForm();
        },
        editItem(item) {
            this.editedIndex = this.localItems.findIndex(i => i.index === item.index);
            this.datos = { name: item.name, value: item.value };
            this.nombreSeleccionado = this.localDatosCrud.find(
                d => d.name.trim().toLowerCase() === item.name.trim().toLowerCase()
            );
        },
        deleteItem(item) {
            const index = this.localItems.findIndex(i => i.index === item.index);
            if (index > -1) {
                this.localItems.splice(index, 1);
                this.$emit('update:items', this.localItems);
            }
        },
        save() {
            if (!this.nombreActual || !this.datos.value) return;
            this.datos.name = this.nombreActual;
            if (this.editedIndex > -1) {
                Object.assign(this.localItems[this.editedIndex], this.datos);
            } else {
                const exists = this.localItems.some(item => item.name === this.datos.name && item.value === this.datos.value);
                if (exists) { this.clearForm(); return; }
                const newIndex = this.localItems.length ? Math.max(...this.localItems.map(i => i.index)) + 1 : 0;
                this.localItems.push({ ...this.datos, index: newIndex });
            }
            this.$emit('update:items', this.localItems);
            this.clearForm();
        },
        // Este método usa el patrón .sync para actualizar la lista de nombres en el padre.
        handleNuevoValor(nuevoValor) {
            this.modalVisible = false;
            const updatedList = [...this.datosCrud];
            const addOptionIndex = updatedList.findIndex(item => item.name === 'Agregar nuevo valor');
            if (addOptionIndex !== -1) {
                updatedList.splice(addOptionIndex, 0, { name: nuevoValor });
            } else {
                updatedList.push({ name: nuevoValor });
            }
            this.$emit('update:datosCrud', updatedList);
            this.$nextTick(() => {
                const nuevoItem = this.localDatosCrud.find(item => item.name === nuevoValor);
                if (nuevoItem) this.nombreSeleccionado = nuevoItem;
            });
        },
    }
}
</script>